/**
 * The app icon, redrawn from `desktop/build/icon.svg`: an Apple-style squircle
 * (a continuous curve, not a rounded rect), a chevron stroked at 79.63 with
 * round caps, and the blue dot under it. Same drawing as the binary, which is
 * what makes a download page look like the thing being downloaded.
 */
const BODY =
  'M 396.640 100.000 h 230.720 c 103.834 0.000 155.751 0.000 195.410 20.207 a 185.400 185.400 0 0 1 81.023 81.023 c 20.207 39.659 20.207 91.576 20.207 195.410 v 230.720 c 0.000 103.834 0.000 155.751 -20.207 195.410 a 185.400 185.400 0 0 1 -81.023 81.023 c -39.659 20.207 -91.576 20.207 -195.410 20.207 h -230.720 c -103.834 0.000 -155.751 0.000 -195.410 -20.207 a 185.400 185.400 0 0 1 -81.023 -81.023 c -20.207 -39.659 -20.207 -91.576 -20.207 -195.410 v -230.720 c 0.000 -103.834 0.000 -155.751 20.207 -195.410 a 185.400 185.400 0 0 1 81.023 -81.023 c 39.659 -20.207 91.576 -20.207 195.410 -20.207 Z';

export function AirlockMark({ size = 30, onDark = false }: { size?: number; onDark?: boolean }): React.JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 1024 1024" style={{ display: 'block', flex: 'none' }} aria-hidden="true">
      <path d={BODY} fill="#E7EAEF" stroke={onDark ? undefined : '#E1E1E4'} strokeWidth={onDark ? undefined : 8} />
      <path
        d="M 319.55 626.71 L 497.05 350.54 Q 512.00 327.27 526.95 350.54 L 704.45 626.71"
        fill="none"
        stroke="#0B0E13"
        strokeWidth={79.63}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={512} cy={669.61} r={55.3} fill="#2F6AEC" />
    </svg>
  );
}

/** Mark + wordmark: JetBrains Mono 500 at .16em, 10px from the mark. */
export function AirlockLockup({
  size = 30,
  onDark = false,
  labelSize = 13
}: {
  size?: number;
  onDark?: boolean;
  labelSize?: number;
}): React.JSX.Element {
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 10, color: onDark ? '#E7EAEF' : '#12161C' }}>
      <AirlockMark size={size} onDark={onDark} />
      <span
        style={{
          fontFamily: "'JetBrains Mono', ui-monospace, monospace",
          fontSize: labelSize,
          fontWeight: 500,
          letterSpacing: '.16em'
        }}
      >
        AIRLOCK
      </span>
    </span>
  );
}
